import React from 'react'
import { BlankView, BlankViewImageSizes, BlankViewImageVariants } from 'src/Components/blank-view'

type Variant = 'no-data' | 'error'

interface Props {
  variant?: Variant
  imageSize?: BlankViewImageSizes
}

const variantConfig: Record<Variant, { imageVariant: BlankViewImageVariants; title: string; explanation: string }> = {
  'no-data': {
    imageVariant: BlankViewImageVariants.Neutral,
    title: 'system-settings.blank-view.no-data.title',
    explanation: 'system-settings.blank-view.no-data.explanation',
  },
  error: {
    imageVariant: BlankViewImageVariants.Worried,
    title: 'system-settings.blank-view.error.title',
    explanation: 'system-settings.blank-view.error.explanation',
  },
}

/**
 * Standard blank view for system settings sections.
 * Use variant="error" when an API error occurred, omit (or use "no-data") when data is simply absent.
 */
const SystemSettingsBlankView: React.FC<Props> = ({ variant = 'no-data', imageSize = BlankViewImageSizes.Small }) => {
  const { imageVariant, title, explanation } = variantConfig[variant]

  return <BlankView imageVariant={imageVariant} imageSize={imageSize} title={title} explanation={explanation} />
}

export default SystemSettingsBlankView
